<div #bbInput class="input">
	<input [placeholder]="value ? '' : placeholder" type="text" [disabled]="disabled" [(ngModel)]="value" (ngModelChange)="valueChanged()">
</div>